"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomCube = void 0;
var three_1 = require("three");
var dom_1 = require("../dom");
var space_inavader_1 = require("../dom/space-inavader");
var gsap_1 = require("gsap");
var clock_1 = require("../dom/clock");
var function_1 = require("../util/function");
var music_1 = require("../dom/music");
var DomCube = /** @class */ (function () {
    function DomCube(base) {
        this.base = base;
        this.groupOuter = new three_1.Group();
        this.groupInner = new three_1.Group();
        this.init();
    }
    DomCube.prototype.init = function () {
        var _a, _b;
        this.chat = new dom_1.Chat(this.base);
        this.clock = new clock_1.Clock(this.base);
        this.music = new music_1.Music(this.base);
        this.spaceInvader = new space_inavader_1.SpaceInvader(this.base);
        (_a = this.groupInner.scale).set.apply(_a, function_1.cubeLikeConfig.initialScale);
        (_b = this.groupInner.rotation).set.apply(_b, function_1.cubeLikeConfig.initialRotation);
        this.groupInner.add(this.chat.object);
        this.groupInner.add(this.clock.object);
        this.groupInner.add(this.music.object);
        this.groupInner.add(this.spaceInvader.object);
        this.groupOuter.add(this.groupInner);
        this.base.scene2.add(this.groupOuter);
        this.doAnimation();
    };
    DomCube.prototype.doAnimation = function () {
        gsap_1.default.to(this.groupInner.rotation, function_1.cubeLikeConfig.startAnimationInnerRotationConfig);
        gsap_1.default.to(this.groupInner.scale, function_1.cubeLikeConfig.startAnimationInnerScalingConfig);
    };
    DomCube.prototype.showChat = function () {
        gsap_1.default.to(this.groupInner.rotation, function_1.cubeLikeConfig.showChatAnimationInnerRotationConfig);
        var angle = (0, function_1.getTargetAngle)(this.groupOuter.rotation.y);
        gsap_1.default.to(this.groupOuter.rotation, {
            x: 0,
            y: angle,
            z: 0,
            duration: 2
        });
    };
    DomCube.prototype.showMusic = function () {
        gsap_1.default.to(this.groupInner.rotation, function_1.cubeLikeConfig.showMusicAnimationInnerRotationConfig);
        var angle = (0, function_1.getTargetAngle)(this.groupOuter.rotation.y);
        gsap_1.default.to(this.groupOuter.rotation, {
            x: 0,
            y: angle - Math.PI / 4,
            z: 0,
            duration: 2
        });
    };
    DomCube.prototype.update = function (delta) {
        if (!this.base.touched && !this.base.getRotationLockStatus()) {
            this.groupOuter.rotation.y += delta / function_1.cubeLikeConfig.updateParameter;
        }
        this.chat.update();
        this.clock.update();
        this.music.update();
        this.spaceInvader.update();
    };
    return DomCube;
}());
exports.DomCube = DomCube;
